import { getAvatarUsers } from "services/get-avatar-users";

export const avatarUserSearch = async (type, value, minimumLength) => {
  if (type === 'phone' && value && value.length >= minimumLength) {
    const avatarUsers = await getAvatarUsers(type, value);
    return avatarUsers;
  } else if (type === 'taxNumber' && value && value.length >= minimumLength) {
    const avatarUsers = await getAvatarUsers(type, value);
    return avatarUsers;
  }

  return false;
};
